/**
 * @desc 删除订阅数据
 */
const URL = "/rantion-walmart";
import http, { updateResponse } from "@/http";
export function request(shopCode: string, subscriptionId: string, options?: any) {
  return updateResponse(
    http(URL + `/walmart/WalmartNotifications/deleteSubscriptions/${shopCode}/${subscriptionId}`, {
      method: "GET",

      ...options,
    }),
  );
}
